import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_TableOptions,
} from "material-react-table";
import type { AdminCampaignDto } from "Infrastructure/Api/Api";
import { useTableLocalization } from "Utils/TableLocalizationUtils";
import { useMemo } from "react";
import { useResource } from "Translations/Resources";
import { createColumns } from "Components/Admin/Campaigns/CampaignListTable/columns";

type Props = {
  data: Array<AdminCampaignDto>;
  isLoading: boolean;
  isRefetching: boolean;
  onDelete: (id: number) => void;
  rowCount?: number;
  tableProps?: Partial<MRT_TableOptions<AdminCampaignDto>>;
};

export const CampaignListTable = ({
  data,
  isLoading,
  isRefetching,
  onDelete,
  rowCount,
  tableProps,
}: Props) => {
  const { t } = useResource();
  const localization = useTableLocalization();
  const columns = useMemo(() => createColumns(t, onDelete), [t, onDelete]);
  const table = useMaterialReactTable({
    ...tableProps,
    data,
    columns,
    rowCount,
    localization,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      ...tableProps?.initialState,
      density: "compact",
    },
    state: {
      ...tableProps?.state,
      isLoading,
      showProgressBars: isRefetching,
    },
    muiTablePaperProps: {
      sx: { borderRadius: "10px" },
    },
  });

  return <MaterialReactTable table={table} />;
};
